import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-2355b4d1.js';

const gsAlertCss = ".gs-alert{display:inline-block;background:#fff;border-radius:3px;padding:20px;width:300px;max-width:90%;text-align:center}.gs-alert .gs-button{width:100px;margin:0 5px}.gs-alert .gs-alert-icon{margin-bottom:20px;font-size:30px}.gs-alert .gs-alert-icon:before{content:'x';height:40px}.gs-alert.primary .gs-alert-icon:before{content:'⚡'}.gs-alert.secondary .gs-alert-icon:before{content:'📝'}.gs-alert.info .gs-alert-icon:before{content:'💡'}.gs-alert.success .gs-alert-icon:before{content:'✔️'}.gs-alert.warning .gs-alert-icon:before{content:'⚠️'}.gs-alert.danger .gs-alert-icon:before{content:'❌'}.gs-alert .gs-alert-title{margin:10px 0;font-size:18px;line-height:22px;font-weight:400;color:#091E42}.gs-alert .gs-alert-message{margin:10px 0;font-size:14px;line-height:20px;font-weight:400;color:#505F79}.gs-alert .gs-alert-options{margin-top:30px}";

const GsAlert = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.confirmed = createEvent(this, "confirmed", 7);
    this.canceled = createEvent(this, "canceled", 7);
    this.type = 'success';
    this.confirmation = false;
    this.configs = {};
  }
  onConfirmed() {
    this.confirmed && this.confirmed.emit(this);
  }
  onCanceled() {
    this.canceled && this.canceled.emit(this);
  }
  render() {
    return (h(Host, null, h("div", { class: `gs-alert ${this.type}` }, h("div", { class: "gs-alert-icon" }), h("div", { class: "gs-alert-title" }, h("slot", { name: "title" })), h("div", { class: "gs-alert-message" }, h("slot", { name: "message" })), h("div", { class: "gs-alert-options" }, this.getOptions()))));
  }
  getOptions() {
    var _a;
    if (this.confirmation == true || ((_a = this.configs) === null || _a === void 0 ? void 0 : _a.confirmation) == true) {
      return h("div", null, h("gs-button", { onClick: () => this.onCanceled() }, "Cancelar"), h("gs-button", { color: "danger", onClick: () => this.onConfirmed() }, "Continuar"));
    }
    return h("div", null, h("gs-button", { color: "primary", onClick: () => this.onConfirmed() }, "OK"));
  }
};
GsAlert.style = gsAlertCss;

class GsAlertService {
  constructor(app) {
    this.app = app;
    this.items = {};
  }
  count() {
    return Object.keys(this.items).length;
  }
  add(configs = {}) {
    const id = Date.now() + this.count();
    this.items[id] = Object.assign(Object.assign({}, configs), { id });
    this.app.redraw();
    if (configs.confirmation !== true) {
      setTimeout(() => this.remove(id), 5000);
    }
    return this.items[id];
  }
  remove(id) {
    delete this.items[id];
    this.app.redraw();
  }
  info(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ message }, configs), { type: 'info' }));
  }
  success(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ title: 'Show!', message }, configs), { type: 'success' }));
  }
  warning(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ title: 'Oops!', message }, configs), { type: 'warning' }));
  }
  danger(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ title: 'Deu ruim :(', message }, configs), { type: 'danger' }));
  }
  render() {
    return Object.keys(this.items).map((id) => {
      const confirm = () => {
        this.remove(id);
      };
      const cancel = () => {
        this.remove(id);
      };
      return h("gs-alert", { type: this.items[id].type, configs: this.items[id], onConfirmed: () => confirm(), onCanceled: () => cancel() },
        h("div", { slot: "title" }, this.items[id].title),
        h("div", { slot: "message" }, this.items[id].message));
    });
  }
}

class GsAuthService {
  constructor(app) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    this.app = app;
    this.default_image = '';
    this.default_permissions = [];
    if ((_b = (_a = this.app.args) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.image) {
      this.default_image = (_d = (_c = this.app.args) === null || _c === void 0 ? void 0 : _c.auth) === null || _d === void 0 ? void 0 : _d.image.toString();
    }
    if ((_f = (_e = this.app.args) === null || _e === void 0 ? void 0 : _e.auth) === null || _f === void 0 ? void 0 : _f.permissions) {
      this.default_permissions = (_h = (_g = this.app.args) === null || _g === void 0 ? void 0 : _g.auth) === null || _h === void 0 ? void 0 : _h.permissions;
    }
    this.login(this.app.storage.get('GS_AUTH_USER'));
  }
  login(user) {
    this.isUser() != !!user;
    this.setUser(user);
  }
  logout() {
    this.login(null);
    this.app.storage.clear();
  }
  setUser(user) {
    this.app.storage.set('GS_AUTH_USER', this.user = user);
    this.app.redraw();
  }
  getUser() {
    return this.user;
  }
  isUser() {
    return !!this.user;
  }
  isGuest() {
    return !this.user;
  }
  attr(field, template = null) {
    return this.isUser() ? this.user[field] : template;
  }
  id() {
    return this.attr('id', '');
  }
  nome() {
    return this.attr('nome', '');
  }
  username() {
    return this.attr('username', '');
  }
  email() {
    return this.attr('email', '');
  }
  image() {
    return this.attr('picture', this.default_image);
  }
  token() {
    return this.attr('token', '');
  }
  refreshToken() {
    return this.attr('refreshToken', '');
  }
  permissions() {
    return this.attr('permissions', this.default_permissions);
  }
  can(permission) {
    return this.isUser() && this.permissions() ? this.permissions().indexOf(permission) >= 0 : false;
  }
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Hashids = /*#__PURE__*/function () {
  function Hashids(salt, minLength, alphabet, seps) {
    if (salt === void 0) {
      salt = '';
    }

    if (minLength === void 0) {
      minLength = 0;
    }

    if (alphabet === void 0) {
      alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
    }

    if (seps === void 0) {
      seps = 'cfhistuCFHISTU';
    }

    this.minLength = minLength;

    if (typeof minLength !== 'number') {
      throw new TypeError("Hashids: Provided 'minLength' has to be a number (is " + typeof minLength + ")");
    }

    if (typeof salt !== 'string') {
      throw new TypeError("Hashids: Provided 'salt' has to be a string (is " + typeof salt + ")");
    }

    if (typeof alphabet !== 'string') {
      throw new TypeError("Hashids: Provided alphabet has to be a string (is " + typeof alphabet + ")");
    }

    var saltChars = Array.from(salt);
    var alphabetChars = Array.from(alphabet);
    var sepsChars = Array.from(seps);
    this.salt = saltChars;
    var uniqueAlphabet = keepUnique(alphabetChars);

    if (uniqueAlphabet.length < minAlphabetLength) {
      throw new Error("Hashids: alphabet must contain at least " + minAlphabetLength + " unique characters, provided: " + uniqueAlphabet.join(''));
    }
    /** `alphabet` should not contains `seps` */


    this.alphabet = withoutChars(uniqueAlphabet, sepsChars);
    /** `seps` should contain only characters present in `alphabet` */

    var filteredSeps = onlyChars(sepsChars, uniqueAlphabet);
    this.seps = shuffle(filteredSeps, saltChars);
    var sepsLength;
    var diff;

    if (this.seps.length === 0 || this.alphabet.length / this.seps.length > sepDiv) {
      sepsLength = Math.ceil(this.alphabet.length / sepDiv);

      if (sepsLength > this.seps.length) {
        var _this$seps;

        diff = sepsLength - this.seps.length;

        (_this$seps = this.seps).push.apply(_this$seps, _toConsumableArray(this.alphabet.slice(0, diff)));

        this.alphabet = this.alphabet.slice(diff);
      }
    }

    this.alphabet = shuffle(this.alphabet, saltChars);
    var guardCount = Math.ceil(this.alphabet.length / guardDiv);

    if (this.alphabet.length < 3) {
      this.guards = this.seps.slice(0, guardCount);
      this.seps = this.seps.slice(guardCount);
    } else {
      this.guards = this.alphabet.slice(0, guardCount);
      this.alphabet = this.alphabet.slice(guardCount);
    }

    this.guardsRegExp = makeAnyOfCharsRegExp(this.guards);
    this.sepsRegExp = makeAnyOfCharsRegExp(this.seps);
    this.allowedCharsRegExp = makeAtLeastSomeCharRegExp([].concat(_toConsumableArray(this.alphabet), _toConsumableArray(this.guards), _toConsumableArray(this.seps)));
  }

  var _proto = Hashids.prototype;

  _proto.encode = function encode(first) {
    for (var _len = arguments.length, numbers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      numbers[_key - 1] = arguments[_key];
    }

    var ret = '';

    if (Array.isArray(first)) {
      numbers = first;
    } else {
      // eslint-disable-next-line eqeqeq
      numbers = [].concat(_toConsumableArray(first != null ? [first] : []), _toConsumableArray(numbers));
    }

    if (!numbers.length) {
      return ret;
    }

    if (!numbers.every(isIntegerNumber)) {
      numbers = numbers.map(function (n) {
        return typeof n === 'bigint' || typeof n === 'number' ? n : safeParseInt10(String(n));
      });
    }

    if (!numbers.every(isPositiveAndFinite)) {
      return ret;
    }

    return this._encode(numbers).join('');
  };

  _proto.decode = function decode(id) {
    if (!id || typeof id !== 'string' || id.length === 0) return [];
    return this._decode(id);
  }
  /**
   * @description Splits a hex string into groups of 12-digit hexadecimal numbers,
   * then prefixes each with '1' and encodes the resulting array of numbers
   *
   * Encoding '00000000000f00000000000f000f' would be the equivalent of:
   * Hashids.encode([0x100000000000f, 0x100000000000f, 0x1000f])
   *
   * This means that if your environment supports BigInts,
   * you will get different (shorter) results if you provide
   * a BigInt representation of your hex and use `encode` directly, e.g.:
   * Hashids.encode(BigInt(`0x${hex}`))
   *
   * To decode such a representation back to a hex string, use the following snippet:
   * Hashids.decode(id)[0].toString(16)
   */
  ;

  _proto.encodeHex = function encodeHex(hex) {
    switch (typeof hex) {
      case 'bigint':
        hex = hex.toString(16);
        break;

      case 'string':
        if (!/^[0-9a-fA-F]+$/.test(hex)) return '';
        break;

      default:
        throw new Error("Hashids: The provided value is neither a string, nor a BigInt (got: " + typeof hex + ")");
    }

    var numbers = splitAtIntervalAndMap(hex, 12, function (part) {
      return parseInt("1" + part, 16);
    });
    return this.encode(numbers);
  };

  _proto.decodeHex = function decodeHex(id) {
    return this.decode(id).map(function (number) {
      return number.toString(16).slice(1);
    }).join('');
  };

  _proto._encode = function _encode(numbers) {
    var _this = this;

    var alphabet = this.alphabet;
    var numbersIdInt = numbers.reduce(function (last, number, i) {
      return last + (typeof number === 'bigint' ? Number(number % BigInt(i + 100)) : number % (i + 100));
    }, 0);
    var ret = [alphabet[numbersIdInt % alphabet.length]];
    var lottery = ret.slice();
    var seps = this.seps;
    var guards = this.guards;
    numbers.forEach(function (number, i) {
      var _ret;

      var buffer = lottery.concat(_this.salt, alphabet);
      alphabet = shuffle(alphabet, buffer);
      var last = toAlphabet(number, alphabet);

      (_ret = ret).push.apply(_ret, _toConsumableArray(last));

      if (i + 1 < numbers.length) {
        var charCode = last[0].codePointAt(0) + i;
        var extraNumber = typeof number === 'bigint' ? Number(number % BigInt(charCode)) : number % charCode;
        ret.push(seps[extraNumber % seps.length]);
      }
    });

    if (ret.length < this.minLength) {
      var prefixGuardIndex = (numbersIdInt + ret[0].codePointAt(0)) % guards.length;
      ret.unshift(guards[prefixGuardIndex]);

      if (ret.length < this.minLength) {
        var suffixGuardIndex = (numbersIdInt + ret[2].codePointAt(0)) % guards.length;
        ret.push(guards[suffixGuardIndex]);
      }
    }

    var halfLength = Math.floor(alphabet.length / 2);

    while (ret.length < this.minLength) {
      var _ret2, _ret3;

      alphabet = shuffle(alphabet, alphabet);

      (_ret2 = ret).unshift.apply(_ret2, _toConsumableArray(alphabet.slice(halfLength)));

      (_ret3 = ret).push.apply(_ret3, _toConsumableArray(alphabet.slice(0, halfLength)));

      var excess = ret.length - this.minLength;

      if (excess > 0) {
        var halfOfExcess = excess / 2;
        ret = ret.slice(halfOfExcess, halfOfExcess + this.minLength);
      }
    }

    return ret;
  };

  _proto.isValidId = function isValidId(id) {
    return this.allowedCharsRegExp.test(id);
  };

  _proto._decode = function _decode(id) {
    if (!this.isValidId(id)) {
      throw new Error("The provided ID (" + id + ") is invalid, as it contains characters that do not exist in the alphabet (" + this.guards.join('') + this.seps.join('') + this.alphabet.join('') + ")");
    }

    var idGuardsArray = id.split(this.guardsRegExp);
    var splitIndex = idGuardsArray.length === 3 || idGuardsArray.length === 2 ? 1 : 0;
    var idBreakdown = idGuardsArray[splitIndex];
    if (idBreakdown.length === 0) return [];
    var lotteryChar = idBreakdown[Symbol.iterator]().next().value;
    var idArray = idBreakdown.slice(lotteryChar.length).split(this.sepsRegExp);
    var lastAlphabet = this.alphabet;
    var result = [];

    for (var _iterator = _createForOfIteratorHelperLoose(idArray), _step; !(_step = _iterator()).done;) {
      var subId = _step.value;
      var buffer = [lotteryChar].concat(_toConsumableArray(this.salt), _toConsumableArray(lastAlphabet));
      var nextAlphabet = shuffle(lastAlphabet, buffer.slice(0, lastAlphabet.length));
      result.push(fromAlphabet(Array.from(subId), nextAlphabet));
      lastAlphabet = nextAlphabet;
    } // if the result is different from what we'd expect, we return an empty result (malformed input):


    if (this._encode(result).join('') !== id) return [];
    return result;
  };

  return Hashids;
}();
var minAlphabetLength = 16;
var sepDiv = 3.5;
var guardDiv = 12;
var keepUnique = function keepUnique(content) {
  return Array.from(new Set(content));
};
var withoutChars = function withoutChars(chars, _withoutChars) {
  return chars.filter(function (char) {
    return !_withoutChars.includes(char);
  });
};
var onlyChars = function onlyChars(chars, keepChars) {
  return chars.filter(function (char) {
    return keepChars.includes(char);
  });
};

var isIntegerNumber = function isIntegerNumber(n) {
  return typeof n === 'bigint' || !Number.isNaN(Number(n)) && Math.floor(Number(n)) === n;
};

var isPositiveAndFinite = function isPositiveAndFinite(n) {
  return typeof n === 'bigint' || n >= 0 && Number.isSafeInteger(n);
};

function shuffle(alphabetChars, saltChars) {
  if (saltChars.length === 0) {
    return alphabetChars;
  }

  var integer;
  var transformed = alphabetChars.slice();

  for (var i = transformed.length - 1, v = 0, p = 0; i > 0; i--, v++) {
    v %= saltChars.length;
    p += integer = saltChars[v].codePointAt(0);
    var j = (integer + v + p) % i; // swap characters at positions i and j

    var a = transformed[i];
    var b = transformed[j];
    transformed[j] = a;
    transformed[i] = b;
  }

  return transformed;
}

var toAlphabet = function toAlphabet(input, alphabetChars) {
  var id = [];

  if (typeof input === 'bigint') {
    var alphabetLength = BigInt(alphabetChars.length);

    do {
      id.unshift(alphabetChars[Number(input % alphabetLength)]);
      input = input / alphabetLength;
    } while (input > BigInt(0));
  } else {
    do {
      id.unshift(alphabetChars[input % alphabetChars.length]);
      input = Math.floor(input / alphabetChars.length);
    } while (input > 0);
  }

  return id;
};

var fromAlphabet = function fromAlphabet(inputChars, alphabetChars) {
  return inputChars.reduce(function (carry, item) {
    var index = alphabetChars.indexOf(item);

    if (index === -1) {
      throw new Error("The provided ID (" + inputChars.join('') + ") is invalid, as it contains characters that do not exist in the alphabet (" + alphabetChars.join('') + ")");
    }

    if (typeof carry === 'bigint') {
      return carry * BigInt(alphabetChars.length) + BigInt(index);
    }

    var value = carry * alphabetChars.length + index;
    var isSafeValue = Number.isSafeInteger(value);

    if (isSafeValue) {
      return value;
    } else {
      if (typeof BigInt === 'function') {
        return BigInt(carry) * BigInt(alphabetChars.length) + BigInt(index);
      } else {
        // we do not have support for BigInt:
        throw new Error("Unable to decode the provided string, due to lack of support for BigInt numbers in the current environment");
      }
    }
  }, 0);
};

var safeToParseNumberRegExp = /^\+?[0-9]+$/;

var safeParseInt10 = function safeParseInt10(str) {
  return safeToParseNumberRegExp.test(str) ? parseInt(str, 10) : NaN;
};

var splitAtIntervalAndMap = function splitAtIntervalAndMap(str, nth, map) {
  return Array.from({
    length: Math.ceil(str.length / nth)
  }, function (_, index) {
    return map(str.slice(index * nth, (index + 1) * nth));
  });
};

var makeAnyOfCharsRegExp = function makeAnyOfCharsRegExp(chars) {
  return new RegExp(chars.map(function (char) {
    return escapeRegExp(char);
  }) // we need to sort these from longest to shortest,
  // as they may contain multibyte unicode characters (these should come first)
  .sort(function (a, b) {
    return b.length - a.length;
  }).join('|'));
};

var makeAtLeastSomeCharRegExp = function makeAtLeastSomeCharRegExp(chars) {
  return new RegExp("^[" + chars.map(function (char) {
    return escapeRegExp(char);
  }) // we need to sort these from longest to shortest,
  // as they may contain multibyte unicode characters (these should come first)
  .sort(function (a, b) {
    return b.length - a.length;
  }).join('') + "]+$");
};

var escapeRegExp = function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

const global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var inited = false;
function init () {
  inited = true;
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }

  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;
}

function toByteArray (b64) {
  if (!inited) {
    init();
  }
  var i, j, l, tmp, placeHolders, arr;
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

  // base64 is 4/3 + up to two characters of the original data
  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = (tmp >> 16) & 0xFF;
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
    output.push(tripletToBase64(tmp));
  }
  return output.join('')
}

function fromByteArray (uint8) {
  if (!inited) {
    init();
  }
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[(tmp << 4) & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
    output += lookup[tmp >> 10];
    output += lookup[(tmp >> 4) & 0x3F];
    output += lookup[(tmp << 2) & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('')
}

function read (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? (nBytes - 1) : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & ((1 << (-nBits)) - 1);
  s >>= (-nBits);
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1);
  e >>= (-nBits);
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

function write (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
  var i = isLE ? 0 : (nBytes - 1);
  var d = isLE ? 1 : -1;
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
}

var toString = {}.toString;

var isArray = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

var INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
  ? global$1.TYPED_ARRAY_SUPPORT
  : true;

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr
};

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
};

function allocUnsafe (that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
};

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that
}

function fromObject (that, obj) {
  if (internalIsBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len);
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
};

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!internalIsBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer
};

function byteLength (string, encoding) {
  if (internalIsBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString (encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap (b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this
};

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this
};

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this
};

Buffer.prototype.toString = function toString () {
  var length = this.length | 0;
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
};

Buffer.prototype.equals = function equals (b) {
  if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
};

Buffer.prototype.inspect = function inspect () {
  var str = '';
  var max = INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>'
};

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!internalIsBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset;  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1);
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (internalIsBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
};

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
};

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
};

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed;
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
};

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return fromByteArray(buf)
  } else {
    return fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    );
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val
};

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val
};

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset]
};

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | (this[offset + 1] << 8)
};

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return (this[offset] << 8) | this[offset + 1]
};

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
};

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
};

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
};

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | (this[offset + 1] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | (this[offset] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
};

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
};

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, true, 23, 4)
};

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, false, 23, 4)
};

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, true, 52, 8)
};

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, false, 52, 8)
};

function checkInt (buf, value, offset, ext, max, min) {
  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = (value & 0xff);
  return offset + 1
};

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24);
    this[offset + 2] = (value >>> 16);
    this[offset + 1] = (value >>> 8);
    this[offset] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = (value & 0xff);
  return offset + 1
};

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
    this[offset + 2] = (value >>> 16);
    this[offset + 3] = (value >>> 24);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4);
  }
  write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
};

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
};

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8);
  }
  write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    );
  }

  return len
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = internalIsBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        }

        // valid lead
        leadSurrogate = codePoint;

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray
}


function base64ToBytes (str) {
  return toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i];
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
}

function isFastBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
}

class GsCryptService {
  constructor(app) {
    var _a, _b, _c, _d;
    this.app = app;
    this._salt = '1qazxsw2wesdcd23werdfcvb54r6tyghb687yujhn8uijkmn0oijkmnpoklm';
    if ((_b = (_a = this.app.args) === null || _a === void 0 ? void 0 : _a.crypt) === null || _b === void 0 ? void 0 : _b.salt) {
      this._salt = (_d = (_c = this.app.args) === null || _c === void 0 ? void 0 : _c.crypt) === null || _d === void 0 ? void 0 : _d.salt.toString();
    }
    this._hashids = new Hashids(this._salt);
  }
  salt() {
    return this._salt;
  }
  encode(value) {
    const hex = Buffer.from(value, 'utf8').toString('hex');
    return this._hashids.encodeHex(hex);
  }
  decode(value) {
    const decoded = this._hashids.decodeHex(value);
    return Buffer.from(decoded, 'hex').toString('utf8');
  }
}

class GsStorageService {
  constructor(app) {
    var _a, _b;
    this.app = app;
    this.exceptions = [
      'GS_STORAGE_ENCODE',
    ];
    if ((_b = (_a = this.app.args) === null || _a === void 0 ? void 0 : _a.storage) === null || _b === void 0 ? void 0 : _b.exceptions) {
      this.exceptions = [...this.exceptions, ...this.app.args.storage.exceptions];
    }
    let encode = localStorage.getItem(this.key('GS_STORAGE_ENCODE'));
    if (encode === null) {
      encode = this.app.crypt.encode(this.app.env);
    }
    if (encode !== this.app.crypt.encode(this.app.env)) {
      this.clear();
      window.location.reload(true);
    }
    localStorage.setItem(this.key('GS_STORAGE_ENCODE'), this.app.crypt.encode(this.app.env));
  }
  key(key, force = false) {
    return this.app.isProduction() || force || key === 'GS_STORAGE_ENCODE' ? this.app.crypt.encode(key) : key;
  }
  get(key, standard = null) {
    let value = localStorage.getItem(this.key(key));
    try {
      if (value === undefined || value === null || value === 'null') {
        return standard;
      }
      if (this.app.isProduction()) {
        value = this.app.crypt.decode(value);
      }
      return JSON.parse(value);
    }
    catch (e) {
      return standard;
    }
  }
  set(key, value) {
    if (value === undefined || value === null || value === 'null') {
      this.del(key);
    }
    else {
      value = JSON.stringify(value);
      if (this.app.isProduction()) {
        value = this.app.crypt.encode(value);
      }
      localStorage.setItem(this.key(key), value);
    }
    return this;
  }
  del(key) {
    localStorage.removeItem(this.key(key));
    return this;
  }
  clear() {
    const exceptions = this.exceptions.reduce((acc, key) => {
      acc[key] = localStorage.getItem(this.key(key.toString()));
      return acc;
    }, {});
    localStorage.clear();
    this.exceptions.map((key) => localStorage.setItem(this.key(key), exceptions[key]));
    return this;
  }
}

class GsMenuService {
  constructor(app) {
    var _a, _b, _c, _d;
    this.app = app;
    this.opened = true;
    if ((_b = (_a = this.app.args) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.opened) {
      this.opened = (_d = (_c = this.app.args) === null || _c === void 0 ? void 0 : _c.menu) === null || _d === void 0 ? void 0 : _d.opened;
    }
  }
  open() {
    if (this.isOpened()) {
      return;
    }
    this.opened = true;
    this.app.redraw();
    if (this.app.mode.isOver()) {
      this.app.context.close();
      this.app.dropdown.close();
    }
  }
  close() {
    if (this.isClosed()) {
      return;
    }
    this.opened = false;
    this.app.redraw();
  }
  toggle() {
    this.opened ? this.close() : this.open();
  }
  isOpened() {
    return this.opened == true;
  }
  isClosed() {
    return this.opened == false;
  }
}

class GsNotifyService {
  constructor(app) {
    this.app = app;
    this.items = {};
  }
  count() {
    return Object.keys(this.items).length;
  }
  add(configs = {}) {
    const id = Date.now() + this.count();
    this.items[id] = Object.assign(Object.assign({}, configs), { id });
    this.app.redraw();
    if (configs.confirmation !== true) {
      setTimeout(() => this.remove(id), 5000);
    }
    return this.items[id];
  }
  remove(id) {
    delete this.items[id];
    this.app.redraw();
  }
  info(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ message }, configs), { type: 'info' }));
  }
  success(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ message }, configs), { type: 'success' }));
  }
  warning(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ message }, configs), { type: 'warning' }));
  }
  danger(message, configs = {}) {
    return this.add(Object.assign(Object.assign({ message }, configs), { type: 'danger' }));
  }
  render() {
    return Object.keys(this.items).map((id) => {
      return h("gs-notify", { type: this.items[id].type, configs: this.items[id] },
        h("div", { class: "tx-bolder" }, this.items[id].title),
        h("div", null, this.items[id].message));
    });
  }
}

class GsLoaderService {
  constructor(app) {
    var _a, _b, _c, _d;
    this.app = app;
    this.items = {};
    if ((_b = (_a = this.app.args) === null || _a === void 0 ? void 0 : _a.loader) === null || _b === void 0 ? void 0 : _b.image) {
      this.default_image = (_d = (_c = this.app.args) === null || _c === void 0 ? void 0 : _c.loader) === null || _d === void 0 ? void 0 : _d.image;
    }
  }
  reset() {
    this.items = {};
    this.app.redraw();
  }
  count() {
    return Object.keys(this.items).length;
  }
  isActive() {
    return this.count() > 0;
  }
  isInactive() {
    return this.count() === 0;
  }
  add(configs = {}) {
    const id = Date.now() + this.count();
    this.items[id] = Object.assign(Object.assign({ image: this.default_image }, configs), { id });
    this.app.redraw();
    return this.items[id];
  }
  remove(id) {
    delete this.items[id];
    this.app.redraw();
  }
  wait(promise, configs = {}) {
    const item = this.add(configs);
    promise.then(() => this.remove(item.id));
    promise.catch(() => this.remove(item.id));
    return promise;
  }
  render() {
    return Object.keys(this.items).filter(item => item).map((id) => {
      return h("gs-loader", { image: this.items[id].image, header: this.items[id].header, message: this.items[id].message });
    }).shift();
  }
}

class GsContextService {
  constructor(app) {
    this.app = app;
    this.opened = false;
  }
  open() {
    if (this.isOpened()) {
      return;
    }
    this.opened = true;
    this.app.redraw();
    this.app.dropdown.close();
    if (this.app.mode.isOver()) {
      this.app.menu.close();
    }
  }
  close() {
    if (this.isClosed()) {
      return;
    }
    this.opened = false;
    this.app.redraw();
  }
  toggle() {
    this.opened ? this.close() : this.open();
  }
  isOpened() {
    return this.opened == true;
  }
  isClosed() {
    return this.opened == false;
  }
}

class GsModeService {
  constructor(app) {
    var _a, _b, _c, _d;
    this.app = app;
    this.type = 'push';
    if ((_b = (_a = this.app.args) === null || _a === void 0 ? void 0 : _a.mode) === null || _b === void 0 ? void 0 : _b.type) {
      this.type = (_d = (_c = this.app.args) === null || _c === void 0 ? void 0 : _c.mode) === null || _d === void 0 ? void 0 : _d.type.toString();
    }
  }
  get() {
    return this.type;
  }
  set(mode) {
    this.type = mode;
    this.app.redraw();
  }
  toggle() {
    this.isOver() ? this.push() : this.over();
  }
  //
  // PUSH
  //
  isPush() {
    return this.type == 'push';
  }
  push() {
    if (this.isPush()) {
      return;
    }
    this.set('push');
    if (this.app.menu.isClosed()) {
      this.app.menu.open();
    }
  }
  //
  // OVER
  //
  isOver() {
    return this.type == 'over';
  }
  over() {
    if (this.isOver()) {
      return;
    }
    this.set('over');
    if (this.app.menu.isOpened()) {
      this.app.menu.close();
    }
  }
}

class GsDropdownService {
  constructor(app) {
    this.app = app;
    this.opened = false;
  }
  open() {
    if (this.isOpened()) {
      return;
    }
    this.opened = true;
    this.app.redraw();
    this.app.context.close();
    if (this.app.mode.isOver()) {
      this.app.menu.close();
    }
  }
  close() {
    if (this.isClosed()) {
      return;
    }
    this.opened = false;
    this.app.redraw();
  }
  toggle() {
    this.opened ? this.close() : this.open();
  }
  isOpened() {
    return this.opened == true;
  }
  isClosed() {
    return this.opened == false;
  }
}

class GsOverlayService {
  constructor(app) {
    this.app = app;
    this.opened = false;
  }
  open() {
    if (this.isOpened()) {
      return;
    }
    this.opened = true;
    this.app.redraw();
    this.app.dropdown.close();
    if (this.app.mode.isOver()) {
      this.app.menu.close();
    }
  }
  close() {
    if (this.isClosed()) {
      return;
    }
    this.opened = false;
    this.app.redraw();
  }
  click() {
    this.app.context.close();
    this.app.dropdown.close();
  }
  toggle() {
    this.opened ? this.close() : this.open();
  }
  isOpened() {
    return this.opened == true;
  }
  isClosed() {
    return this.opened == false;
  }
}

class GsSizeService {
  constructor(app) {
    this.app = app;
    this.maxMobile = 767;
    this.maxTablet = 992;
    this._width = window.innerWidth;
    this._height = window.innerHeight;
    window.addEventListener('resize', () => this.update(this.app.element.querySelector('.GS_APP').scrollWidth, this.app.element.querySelector('.GS_APP').scrollHeight));
  }
  update(width, height) {
    this._width = width;
    this._height = height;
    this.app.redraw();
  }
  width() {
    return this._width;
  }
  height() {
    return this._height;
  }
  isMobile() {
    return this.width() <= this.maxMobile;
  }
  isTablet() {
    return this.width() <= this.maxTablet;
  }
}

class GsBarsService {
  constructor(app) {
    this.app = app;
    this.opened = true;
  }
  open() {
    if (this.isOpened()) {
      return;
    }
    this.opened = true;
    this.app.redraw();
  }
  close() {
    if (this.isClosed()) {
      return;
    }
    this.opened = false;
    this.app.redraw();
    this.app.context.close();
    this.app.dropdown.close();
    if (this.app.mode.isOver()) {
      this.app.menu.close();
    }
  }
  toggle() {
    this.opened ? this.close() : this.open();
  }
  isOpened() {
    return this.opened == true;
  }
  isClosed() {
    return this.opened == false;
  }
}

class GsFocusService {
  constructor(app) {
    this.app = app;
    this.status = true;
    window.addEventListener('focus', () => this.setStatus(true));
    window.addEventListener('blur', () => this.setStatus(false));
  }
  setStatus(status) {
    this.status = status;
    this.app.redraw();
  }
  getStatus() {
    return this.status;
  }
  isActive() {
    return this.status == true;
  }
  isInactive() {
    return this.status == false;
  }
}

class GsVisibilityService {
  constructor(app) {
    this.app = app;
    this.type = 'grid';
    this.type = this.app.storage.get('GS_VISIBILITY_TYPE', 'grid');
  }
  grid() {
    this.setType('grid');
  }
  list() {
    this.setType('list');
  }
  setType(type) {
    this.type = type;
    this.app.redraw();
  }
  getType() {
    return this.isGrid() ? 'grid' : 'list';
  }
  isGrid() {
    if (this.app.size.isMobile()) {
      return true;
    }
    return this.type == 'grid';
  }
  isList() {
    if (this.app.size.isMobile()) {
      return false;
    }
    return this.type == 'list';
  }
}

class GsNetService {
  constructor(app) {
    this.app = app;
    this.status = true;
    this.status = navigator.onLine;
    window.addEventListener('online', () => this.setStatus(navigator.onLine));
    window.addEventListener('offline', () => this.setStatus(navigator.onLine));
  }
  setStatus(status) {
    this.status = status;
    this.app.redraw();
  }
  getStatus() {
    return this.status;
  }
  online() {
    return this.status == true;
  }
  offline() {
    return this.status == false;
  }
}

const gsAppCss = ".GS_APP{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-wrap:nowrap;flex-direction:column;align-items:stretch;overflow:hidden}.GS_APP_HEADER{height:56px;margin-top:0;transition:all 0.4s ease;background:#fff;border:0 solid #EBECF0;border-bottom-width:1px;z-index:700}.GS_APP_CONTAINER{position:relative;display:flex;flex:1;flex-wrap:nowrap;flex-direction:row;align-items:stretch;transition:all 0.4s ease;z-index:800}.GS_APP_OVERLAY,.GS_APP_MENU_OVERLAY,.GS_APP_SNAP_OVERLAY,.GS_APP_ALERT_OVERLAY,.GS_APP_LOADER_OVERLAY{position:absolute;top:0;right:0;bottom:0;left:0;transition:all 0.4s ease;pointer-events:none;background:rgba(0, 0, 0, 0);z-index:900;overflow:hidden}.GS_APP_CONTENT{position:relative;flex:1;overflow:hidden;transition:all 0.4s ease;z-index:800;background:#fff}.GS_APP_MENU{position:relative;display:flex;overflow-y:auto;overflow-x:hidden;width:240px;height:100%;z-index:1000;transition:all 0.4s ease;color:#fff;background:#091E42}.GS_APP_MENU>[slot]{display:block;width:100%}.GS_APP_CONTEXT{position:absolute;top:0;right:0;bottom:0;background:#fff;transform:translate(100%, 0);transition:all 0.4s ease;z-index:1000}.GS_APP_DROPDOWN{position:absolute;left:50%;bottom:0;background:#fff;transform:translate(-50%, 100%);transition:all 0.4s ease;z-index:1000}.GS_APP_ALERT_OVERLAY .gs-alert{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);transition:all 0.4s ease}.GS_APP_LOADER_OVERLAY .gs-loader{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);transition:all 0.4s ease}.GS_APP.overlay .GS_APP_OVERLAY,.GS_APP.over.opened .GS_APP_MENU_OVERLAY,.GS_APP.alert .GS_APP_ALERT_OVERLAY,.GS_APP.loader .GS_APP_LOADER_OVERLAY{background:rgba(0, 0, 0, 0.75);pointer-events:inherit}.GS_APP.overlay.context .GS_APP_CONTEXT{transform:translate(0, 0);pointer-events:all}.GS_APP.overlay.dropdown .GS_APP_DROPDOWN{transform:translate(-50%, 0);pointer-events:all}.GS_APP.expanded .GS_APP_HEADER{margin-top:-56px}.GS_APP.closed .GS_APP_MENU{margin-left:-240px}.GS_APP.over .GS_APP_MENU{position:absolute;left:0;right:0}";

const GsApp = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.env = 'production';
    this.args = {};
    this.draw = 0;
    this.size = new GsSizeService(this);
    if (this.size.isTablet()) {
      this.args.mode = { type: 'over' };
      this.args.menu = { opened: false };
    }
    this.alert = new GsAlertService(this);
    this.bars = new GsBarsService(this);
    this.overlay = new GsOverlayService(this);
    this.menu = new GsMenuService(this);
    this.mode = new GsModeService(this);
    this.context = new GsContextService(this);
    this.crypt = new GsCryptService(this);
    this.dropdown = new GsDropdownService(this);
    this.focus = new GsFocusService(this);
    this.loader = new GsLoaderService(this);
    this.notify = new GsNotifyService(this);
    this.net = new GsNetService(this);
    this.storage = new GsStorageService(this);
    this.auth = new GsAuthService(this);
    this.visibility = new GsVisibilityService(this);
  }
  //--------------------------------------------------------------------------------------------------------------------
  // SERVICES
  //--------------------------------------------------------------------------------------------------------------------
  async services() {
    return {
      alert: this.alert,
      auth: this.auth,
      bars: this.bars,
      context: this.context,
      crypt: this.crypt,
      dropdown: this.dropdown,
      focus: this.focus,
      loader: this.loader,
      menu: this.menu,
      mode: this.mode,
      notify: this.notify,
      net: this.net,
      overlay: this.overlay,
      storage: this.storage,
      size: this.size,
      visibility: this.visibility,
    };
  }
  //--------------------------------------------------------------------------------------------------------------------
  // RENDER
  //--------------------------------------------------------------------------------------------------------------------
  isProduction() {
    return this.env == 'production';
  }
  isDevelopment() {
    return !this.isProduction();
  }
  redraw() {
    this.draw = this.draw < 1000000 ? this.draw + 1 : 0;
  }
  render() {
    return (h(Host, null, h("div", { class: `GS_APP ${this.getAppClass()}` }, h("div", { class: "GS_APP_HEADER" }, h("slot", { name: "header" })), h("div", { class: "GS_APP_CONTAINER" }, h("div", { class: "GS_APP_MENU" }, h("slot", { name: "menu" })), h("div", { class: "GS_APP_MENU_OVERLAY", onClick: () => this.menu.close() }), h("div", { class: "GS_APP_CONTENT" }, h("gs-screen", null, h("div", { slot: "header" }, this.notify.render()), h("div", { slot: "body" }, h("slot", { name: "content" })), h("div", { slot: "footer" })))), h("div", { class: "GS_APP_OVERLAY", onClick: () => this.overlay.click() }), h("div", { class: "GS_APP_SNAP_OVERLAY" }, h("div", { class: "GS_APP_CONTEXT" }, h("slot", { name: "context" })), h("div", { class: "GS_APP_DROPDOWN" }, h("slot", { name: "dropdown" }))), h("div", { class: "GS_APP_ALERT_OVERLAY" }, this.alert.render()), h("div", { class: "GS_APP_LOADER_OVERLAY" }, this.loader.render()))));
  }
  getAppClass() {
    const classes = [];
    if (this.overlay.isOpened()) {
      classes.push('overlay');
    }
    if (this.alert.count()) {
      classes.push('alert');
    }
    if (this.loader.count()) {
      classes.push('loader');
    }
    if (this.bars.isClosed()) {
      classes.push('expanded');
      classes.push('over');
      classes.push('closed');
    }
    else {
      classes.push('contracted');
      if (this.context.isOpened()) {
        classes.push('overlay');
        classes.push('context');
      }
      if (this.dropdown.isOpened()) {
        classes.push('overlay');
        classes.push('dropdown');
      }
      classes.push(this.size.isTablet() ? 'over' : this.mode.get());
      classes.push(this.menu.isOpened() ? 'opened' : 'closed');
    }
    return classes.join(' ');
  }
  get element() { return getElement(this); }
};
GsApp.style = gsAppCss;

const gsButtonCss = ".gs-button{display:inline-flex;flex-direction:row;justify-content:center;align-items:center;font-style:normal;font-weight:400;text-align:center;vertical-align:middle;border-radius:3px;padding:0 16px 0 16px;transition:all 0.4s ease;color:#505F79;border:1px solid var(--app-grey-400);background:#FFFFFF}.gs-button.xxl{height:70px;font-size:30px}.gs-button.xl{height:60px;font-size:20px}.gs-button.l{height:50px;font-size:16px}.gs-button.m{height:40px;font-size:14px}.gs-button.s{height:30px;font-size:12px}.gs-button.xs{height:20px;font-size:12px}.gs-button.xxs{height:14px;font-size:11px;padding:3px}.gs-button.square{border-radius:0}.gs-button.rounded{border-radius:1000px}.gs-button.circle{padding:0;border-radius:100%}.gs-button.circle.xxl{width:70px;font-size:40px}.gs-button.circle.xl{width:60px;font-size:28px}.gs-button.circle.l{width:50px;font-size:20px}.gs-button.circle.m{width:40px;font-size:17px}.gs-button.circle.s{width:30px;font-size:15px}.gs-button.circle.xs{width:20px;font-size:12px}.gs-button.circle.xxs{width:14px;font-size:11px}.gs-button.disabled{opacity:0.5;cursor:not-allowed}.gs-button:not(.disabled){cursor:pointer}.gs-button.primary,.gs-button.info,.gs-button.success,.gs-button.warning,.gs-button.danger{color:#fff}.gs-button.primary{background:var(--app-primary);border-color:var(--app-primary-600)}.gs-button.primary:hover{background:var(--app-primary-400)}.gs-button.secondary{color:#000;background:var(--app-secondary);border-color:var(--app-secondary-600)}.gs-button.secondary:hover{background:var(--app-secondary-400)}.gs-button.info{background:var(--app-info);border-color:var(--app-info-600)}.gs-button.info:hover{background:var(--app-info-400)}.gs-button.success{background:var(--app-success);border-color:var(--app-success-600)}.gs-button.success:hover{background:var(--app-success-400)}.gs-button.warning{background:var(--app-warning);border-color:var(--app-warning-600)}.gs-button.warning:hover{background:var(--app-warning-400)}.gs-button.danger{background:var(--app-danger);border-color:var(--app-danger-600)}.gs-button.danger:hover{background:var(--app-danger-400)}";

const GsButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.shape = 'edge';
    this.size = 'm';
    this.type = 'flat';
    this.disable = false;
    this.color = 'default';
  }
  render() {
    return (h(Host, null, h("div", { class: `gs-button ${this.disable ? 'disabled' : ''} ${this.shape} ${this.type} ${this.color} ${this.size}` }, h("slot", null, "gs-button"))));
  }
};
GsButton.style = gsButtonCss;

const gsEmptyCss = ".gs-empty{text-align:center}.gs-empty .gs-container{padding:50px;display:flex;flex-wrap:nowrap;flex-direction:column;align-items:center;justify-content:center}.gs-empty .gs-image{margin-bottom:30px}.gs-empty .gs-image img{max-width:280px;max-height:200px}.gs-empty .gs-title{color:#172B4D;font-size:20px;line-height:24px;font-weight:400;max-width:600px;margin-bottom:5px}.gs-empty .gs-subtitle{color:#505F79;font-size:16px;line-height:20px;font-weight:400;max-width:600px}@media (max-width: 767px){.gs-empty .gs-container{padding:50px 10px}}";

const GsEmpty = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("div", { class: "gs-empty" }, h("div", { class: "gs-container" }, h("div", { class: "gs-image" }, h("img", { src: this.image })), h("div", { class: "gs-title" }, h("slot", { name: "title" })), h("div", { class: "gs-subtitle" }, h("slot", { name: "subtitle" }))))));
  }
};
GsEmpty.style = gsEmptyCss;

const gsItemCss = ".gs-item{position:relative;display:flex;flex-wrap:nowrap;flex-direction:row;align-items:stretch}.gs-item>[slot=\"left\"],.gs-item>[slot=\"right\"],.gs-item>[slot=\"content\"]{display:flex;align-items:center;position:relative}.gs-item>[slot=\"content\"]{flex:1 100%}.gs-item>[slot=\"left\"]>*,.gs-item>[slot=\"right\"]>*,.gs-item>[slot=\"content\"]>*{display:inline-block}.gs-item>[slot=\"left\"],.gs-item>[slot=\"content\"]{text-align:left}.gs-item>[slot=\"right\"]{text-align:right}";

const GsItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("div", { class: "gs-item" }, h("slot", { name: "left" }), h("slot", { name: "content" }), h("slot", { name: "right" }))));
  }
};
GsItem.style = gsItemCss;

const gsListHeaderCss = ".gs-list-header{display:block;width:100%;font-size:11px;font-weight:400;letter-spacing:0.4px;opacity:0.7;margin-top:30px;padding:4px 16px;text-transform:uppercase}";

const GsListHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, { class: "gs-list-header" }, h("slot", null)));
  }
};
GsListHeader.style = gsListHeaderCss;

const gsListItemCss = ".gs-list-item{position:relative;display:flex;flex-wrap:nowrap;flex-direction:row;align-items:stretch;cursor:pointer}.gs-list-item,.gs-list-item:visited,.gs-list-item:hover{color:inherit;text-decoration:inherit}.gs-list-item.active:before{position:absolute;content:'';top:0;left:0;bottom:0;width:5px;z-index:100;border-radius:0 3px 3px 0;background:var(--app-primary)}.gs-list-item>[slot=\"left\"],.gs-list-item>[slot=\"right\"],.gs-list-item>[slot=\"content\"]{display:flex;align-items:center;position:relative}.gs-list-item>[slot=\"content\"]{flex:1 100%}.gs-list-item>[slot=\"left\"]>*,.gs-list-item>[slot=\"right\"]>*,.gs-list-item>[slot=\"content\"]>*{display:inline-block}.gs-list-item>[slot=\"left\"],.gs-list-item>[slot=\"content\"]{text-align:left}.gs-list-item>[slot=\"right\"]{text-align:right}.gs-list-item:hover{background:rgba(255, 255, 255, 0.1)}.gs-list-item>[slot=\"content\"]{padding:8px 8px 8px 8px}.gs-list-item>[slot=\"left\"]{padding:8px 8px 8px 16px}.gs-list-item>[slot=\"right\"]{padding:8px 16px 8px 8px}";

const GsListItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.href = 'javascript:';
    this.active = false;
  }
  render() {
    return (h(Host, null, h("a", { class: `gs-list-item ${this.active ? 'active' : ''}`, href: this.href }, h("slot", { name: "left" }), h("slot", { name: "content" }), h("slot", { name: "right" }))));
  }
};
GsListItem.style = gsListItemCss;

const gsNotifyCss = ":host{display:block}.gs-notify{position:relative;margin:0;padding:16px 50px 16px 50px;border:1px solid #000}.gs-notify:before,.gs-notify:after{position:absolute;top:50%;margin-top:-10px;width:20px;height:20px;border-radius:50%;color:#fff;text-align:center;line-height:22px}.gs-notify:before{left:15px}.gs-notify:after{display:none;content:'🗑️';right:15px;}.gs-notify:hover:after{cursor:pointer;display:block}.gs-notify.primary{color:var(--app-primary-700);background:var(--app-primary-100);border-color:var(--app-primary-700)}.gs-notify.primary:before{content:'⚡';}.gs-notify.secondary{color:var(--app-secondary-700);background:var(--app-secondary-100);border-color:var(--app-secondary-700)}.gs-notify.secondary:before{content:'📝';}.gs-notify.info{color:var(--app-info-700);background:var(--app-info-100);border-color:var(--app-info-700)}.gs-notify.info:before{content:'💡';color:#000;}.gs-notify.success{color:var(--app-success-700);background:var(--app-success-100);border-color:var(--app-success-700)}.gs-notify.success:before{content:'✔️';}.gs-notify.warning{color:var(--app-warning-700);background:var(--app-warning-100);border-color:var(--app-warning-700)}.gs-notify.warning:before{content:'⚠️';}.gs-notify.danger{color:var(--app-danger-700);background:var(--app-danger-100);border-color:var(--app-danger-700)}.gs-notify.danger:before{content:'❌';}";

const GsNotify = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.type = 'success';
    this.configs = {};
  }
  render() {
    return (h(Host, null, h("div", { class: `gs-notify ${this.type}` }, h("slot", null))));
  }
};
GsNotify.style = gsNotifyCss;

const gsScreenCss = ".gs-screen{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;display:flex;flex-wrap:nowrap;flex-direction:row;align-items:stretch;justify-content:flex-start;z-index:100}.gs-screen>.gs-screen-left,.gs-screen>.gs-screen-center,.gs-screen>.gs-screen-right{position:relative}.gs-screen>.gs-screen-center{flex:1 100%;overflow-x:hidden;overflow-y:auto;top:0;right:0;bottom:0;left:0;height:100%;display:flex;flex-wrap:nowrap;flex-direction:column;align-items:stretch;justify-content:flex-start;z-index:100}.gs-screen>.gs-screen-center>.gs-screen-header,.gs-screen>.gs-screen-center>.gs-screen-body,.gs-screen>.gs-screen-center>.gs-screen-body-fixed,.gs-screen>.gs-screen-center>.gs-screen-footer{position:relative}.gs-screen>.gs-screen-center>.gs-screen-body{flex:1 100%;overflow-x:hidden;overflow-y:auto}";

const GsScreen = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("section", { class: "gs-screen" }, h("section", { class: "gs-screen-left" }, h("slot", { name: "left" })), h("section", { class: "gs-screen-center" }, h("section", { class: "gs-screen-header" }, h("slot", { name: "header" })), h("section", { class: "gs-screen-body" }, h("slot", { name: "body" })), h("section", { class: "gs-screen-footer" }, h("slot", { name: "footer" }))), h("section", { class: "gs-screen-right" }, h("slot", { name: "right" })))));
  }
};
GsScreen.style = gsScreenCss;

const gsSectionCss = ":host{display:block}.gs-section .gs-container{padding:20px}.gs-section .gs-header{margin-bottom:10px;display:flex;flex-wrap:nowrap;flex-direction:row;align-items:stretch}.gs-section .gs-header .gs-texts{flex:1;display:flex;flex-direction:column;align-items:flex-start;justify-content:center}.gs-section .gs-header .gs-texts .gs-title{font-weight:600;font-size:16px;line-height:24px;color:#091E42}.gs-section .gs-header .gs-texts .gs-subtitle{font-size:17px;line-height:24px;color:#091E42}.gs-section .gs-header .gs-texts .gs-hint{font-size:13px;line-height:18px;color:#5E6C84}.gs-section .gs-options{display:flex;flex-direction:row;align-items:center}@media (max-width: 767px){.gs-section .gs-container{padding:20px 10px}}";

const GsSection = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("div", { class: "gs-section" }, h("div", { class: "gs-container" }, h("div", { class: "gs-header" }, h("div", { class: "gs-texts" }, h("div", { class: "gs-title" }, h("slot", { name: "title" })), h("div", { class: "gs-subtitle" }, h("slot", { name: "subtitle" })), h("div", { class: "gs-hint" }, h("slot", { name: "hint" }))), h("div", { class: "gs-options" }, h("slot", { name: "options" }))), h("div", { class: "gs-body" }, h("slot", { name: "content" }))))));
  }
};
GsSection.style = gsSectionCss;

const gsThumbCss = ".gs-thumb-image{display:inline-block}.gs-thumb-image.circle{border-radius:50%}";

const GsThumb = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.mode = 'circle';
    this.size = 50;
  }
  render() {
    return (h(Host, null, h("img", { class: `gs-thumb-image ${this.mode}`, width: this.size, height: this.size, src: this.image })));
  }
};
GsThumb.style = gsThumbCss;

export { GsAlert as gs_alert, GsApp as gs_app, GsButton as gs_button, GsEmpty as gs_empty, GsItem as gs_item, GsListHeader as gs_list_header, GsListItem as gs_list_item, GsNotify as gs_notify, GsScreen as gs_screen, GsSection as gs_section, GsThumb as gs_thumb };
